<template>
	<div class="pie-chart alarm-list-container">
		<div class="no-scroll-items-container" :style="noScollStyle">
			<ul>
				<li v-for="item in noScrollList" class="alarm-list-item" :key="index">
					<span class="span-bar">
						<strong  class="alarm-level-ball"></strong>
					</span>
					<span v-if="item.resourceIp != null && item.resourceIp != '' "  class="span-bar1">{{item.resourceIp}}</span>
					<span v-else class="span-bar1">N/A</span>
					<span  class="span-title"><a   @click="wsLink(item)" >{{item.wsTitle}}</a></span>
					<span  class= "span-name" >{{item.wsStatus}}</span>
					<span  class="span-text">{{item.wsCreateTime}}</span>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		name: "CsAlarmList",
		props: ['instance'],
		data() {
			return {
				noScollStyle:{},
				scollStyle:{},
				style:{},
				list:[],
				scrollLists:[],
				itemStyle:{
					height:'10%'
				},
				timeOut: 1000,
			}
		},
		computed:{
			//无需滚动列表
			noScrollList(){
				if(this.instance.scrollAll){
					return [];
				}
				/*let list= this.instance.data.filter((item,index)=>{
					return item.alarmLevel==1;
				});*/
				let list= this.instance.data;
				if(list.length>this.instance.amount){
					list=list.slice(0,this.instance.amount);
				}
				return list;
			},
			//滚动列表，根据所传递参数判断，如果scrollAll全部滚动，否则按照告警级别判断滚动
			scrollList(){
				if(this.instance.scrollAll){
					return this.instance.data;
				}
				return this.instance.data.filter((item,index)=>{
					return item.alarmLevel!=1;
				});
			},
		},
		methods: {
			toAlarm(item) {
				localStorage.setItem("alarmList",JSON.stringify([item]));
				//this.$router.push("/alarmIndex/realTimeAlarm/"+item.alarmLevel+"/实时预警列表")
			},
		   resize(){
			   
			},
			//根据样式名称获取指定样式
			getCssRule(ruleName){
				var cssRule=null;
				var ss = document.styleSheets;
			    for (var i = 0; i < ss.length; ++i) {
			        for (var x = 0; x < ss[i].cssRules.length; ++x) {
			            var rule = ss[i].cssRules[x];
			            if (rule.name == ruleName && rule.type == CSSRule.KEYFRAMES_RULE) {
			                cssRule = rule;
			                break;
			            }
			        }
			        if(cssRule!=null){
			        	break;
			        }
	         	}
			    return cssRule;
			},
			//初始化滚动事件
			initScrollEvent(){
				var This=this;
				var ele=This.$el.querySelector(".queen");
				ele.addEventListener("mouseover",function(){
					ele.style.animationPlayState = "paused";  
				},false);
				ele.addEventListener("animationstart", This.animationStart); 
				ele.addEventListener("animationend", This.animationEnd); 
				ele.addEventListener("mouseout",function(){
					ele.style.animationPlayState = "running";  
				},false);
			},
			//滚动开始事件，将滚动数组第一个元素push到数组末尾
			animationStart(){
				var This=this;
				This.list=This.scrollLists;
				var firstEle=This.list[0];
				This.list.push(firstEle);
				This.scrollLists=This.list;
			},
			//滚动结束事件，将数组第一个元素删除
			animationEnd(){
				var This=this;
				This.list.shift(0);
				This.scrollLists=This.list;
				This.style={};
				setTimeout(function(){
					This.style={animation:'alarm-scroll '+(This.timeOut/1000)+"s linear both"};
				},This.timeOut)
			},
			//初始化滚动动画
			initscroll(){
				var This=this;
				this.timeOut=this.instance.timeOut;
				var This=this;
				This.style={animation:'alarm-scroll '+(this.timeOut/1000)+"s linear both"};
			},
			//数据渲染
			appendInstance(){
				if(this.instance.amount){
					var amount=this.instance.amount;
					var percent=(100/(amount-this.noScrollList.length))+'%';
					this.itemStyle={height:percent};
					var cssStyle=this.getCssRule("alarm-scroll");
				 	cssStyle.deleteRule("1");
			 	    cssStyle.appendRule("to{top:-"+percent+"}");
			 	    
			 	    var compare=this.noScrollList.length/amount>1?1:this.noScrollList.length/amount;
			 	    this.noScollStyle={height:compare*100+'%'};
			 	    this.scollStyle={height:(1-compare)*100+'%'};
				}
		 	    
				if(this.scrollLists.length>0){
					this.initscroll();
					this.initScrollEvent();
				}
			},
			noData(){
				
		  	},
		  	initAlarm(){
		  		this.scrollLists=this.instance.data;
				if(this.scrollLists.length>=this.instance.amount){
					this.appendInstance()
				}
		  	},
			wsLink(item){
				this.$router.push({
					path : "/repair",
					name : "repair",
					params : {"wsData" : item.wsSerialNo},
					
				})

			}
		 },
		mounted: function(el) {
			this.initAlarm();
		}

	}
</script>


// WEBPACK FOOTER //
// src/components/alarmlist/CsAlarmList.vue